<template>
  <nna-container :spacing=10>
    <div class="cart">
      <div class="product">
        <md-table md-card>
          <md-table-toolbar>
            <h1 class="md-title text-align-left">Riepilogo ordine</h1>
            <h2 class="md-title text-align-right">{{shop.name}}</h2>
          </md-table-toolbar>
          <md-table-row v-for="product in cart" :key="product.id">
            <md-table-cell>{{product.name}}</md-table-cell> 
            <md-table-cell>
              <div class="product__actions md-layout-item text-align-right">
                <md-button class="md-icon-button md-raised" @click="decreases(product)">
                  <md-icon>remove</md-icon>
                </md-button>            
                <div class="product__amount">{{product.pieces}}</div>
                <md-button class="md-icon-button md-raised" @click="increases(product)">
                  <md-icon>add</md-icon>
                </md-button>       
              </div>
            </md-table-cell>
            <md-table-cell>€{{product.subTotal}}</md-table-cell>
          </md-table-row>
        </md-table>         
        <div class="cart__total md-layout md-gutter mt-7 m-3">
          <div class="md-layout-item text-align-left">
            <div class="cart__totalLabel">Totale</div>
          </div>
          <div class="md-layout-item text-align-right">
            <div class="cart__totalSum">€{{total}}</div>
            <div class="cart__totalShipping" v-if="shopOptions.minAmountOrder > 0">spesa minima €{{shopOptions.minAmountOrder}}</div>
          </div>
        </div>        
        <md-button class="md-raised md-primary" md-align="center" @click="goTo">Invia Ordine</md-button>
      </div>
    </div> 
  </nna-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Cart',
  components: {  
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      cart: 'cart/cart',
      total: 'cart/total',
      shop: 'shops/current',
      shopOptions: 'shops/options'
    }),
  },
  watch: {
    cart(newVal) {
      if(newVal.length === 0) {
        this.$router.push({ name: 'shop.products' })
      }
    }
  },
  methods: {
    ...mapActions({      
    }),
    increases(product) {
      product.pieces += 1
      this.updateCart(product)
    },
    decreases(product) {
      product.pieces -= 1
      this.updateCart(product)
    },
    updateCart(product) {      
      if(product.pieces > 0) {
        this.$store.commit("cart/ADD_TO_CART", product)
      } else {
        this.$store.commit("cart/REMOVE_TO_CART", product)
      }      
    },        
    goTo() {
      this.$router.push({ name: 'checkout' })
    }
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/modules/Shop/pages/Cart.vue